let labelArr = []
const confs = {
    "availConfs": [
        {
            "pola": {
                "label": "Pola",
                "id": "pola-high-webTiles",
                "protected": false,
                "initLat": 35.73032001737288,
                "initLong": -97.46897368793051,
                "initHeight": 771.5452415093926,
                "heading": 318.86444792482433,
                "pitch": -29.054157235114488,
            },
            "gilcrease": {
                "label": "Gilcrease",
                "id": "gilcrease-noProj-webTiles",
                "protected": true,
                "initLat": 36.14446729773398,
                "initLong": -96.07174420112736,
                "initHeight": 695.708781936869,
                "heading": 21.565698379245035,
                "pitch": -11.99247260813766,
            },
            "eastWestConnector": {
                "initLat": 35.733149,
                "initLong": -97.477565,
                "initHeight": 400,
                "protected": true,
                "id": "ewConnector-noProj-webTiles",
                "label": "East-West Connector",
            },
            "fireDamage": {
                "label": "Fire Damage",
                "id": "fire-noProj-webTiles",
                "protected": false,
                "initLat": 35.53051091328026,
                "initLong": -97.52622124619765,
                "initHeight": 827.3279737203364,
                "heading": 310.86634939365194,
                "pitch": -38.49699168519594,
            },
            "ou": {
                "label": "OU Game Day",
                "id": "ou-noProj-webTiles",
                "protected": false,
                "initLat": 35.202990633758795,
                "initLong": -97.43884359119136,
                "initHeight": 565.3083505743022,
                "pitch": -31.200388769618307,
                "heading": 314.7979031354168,
            },
            "southConnector": {
                "protected": true,
                "id": "southConnector-noProj-webTiles",
                "label": "South Connector",
                "initLat": 35.17094093765347,
                "initLong": -97.36694660742828,
                "initHeight": 400,
                "heading": 0.0,
                "pitch": -15.0,
            },
            "tricity": {
                "label": "Tricity",
                "id": "turner-noProj-webTiles",
                "protected": true,
                "initLat": 35.517497580564246,
                "initLong": -97.06969637310142,
                "initHeight": 5721.604428990548,
                "heading": 219.44570695582865,
                "pitch": -14.491491060713386,
            },
            "turner": {
                "label": "Turner",
                "id": "turner-noProj-webTiles",
                "protected": true,
                "initLat": 35.54765063762984,
                "initLong": -97.65647010123472,
                "initHeight": 7280.033825353109,
                "heading": 78.55223286309615,
                "pitch": -8.99828066441686,
            },

            "willRogers": {
                "label": "Will Rogers Turnpike",
                "id": "willRogers-noProj-webTiles",
                "protected": true,
                "initLat": 36.120518152225294,
                "initLong": -95.78660215003892,
                "initHeight": 3025.4474857523987,
                "heading": 43.157218589578456,
                "pitch": -14.996746596211352,
            },
            "pinnacleHeights": {
                "label": "Pinnacle Heights",
                "id": "pinnacleHeights-noProj-webTiles",
                "protected": true,
                "initLat": 36.298518,
                "initLong": -94.188089,
                "initHeight": 400,
                "heading": 0.0,
                "pitch": -15.0,
            },
            "NBX_BQBG_YBIR_PBHAGL": {
            "dir": "NBX_BQBG_YBIR_PBHAGL",
            "label": "NBX_BQBG_YBIR_PBHAGL",
            "protected": true,
            "initLat": 33.818821926026274,
            "initLong": -97.1462832033791,
            "initHeight":  1113.58871818551,
            "heading": 146.31303569810575,
            "pitch": -22.781699362707105
        },
            "NBX_BQBG_YBIR_PBHAGL_KTX": {
            "dir": "NBX_BQBG_YBIR_PBHAGL_KTX",
            "label": "NBX_BQBG_YBIR_PBHAGL_KTX",
            "protected": true,
            "initLat": 33.818821926026274,
            "initLong": -97.1462832033791,
            "initHeight":  1113.58871818551,
            "heading": 146.31303569810575,
            "pitch": -20.349891439795368
        },
            "SBKUBYR_KTX": {
            "dir": "SBKUBYR_KTX",
            "label": "SBKUBYR_KTX",
            "protected": true,
            "initLat": 36.765690242226235,
            "initLong": -95.8428676315364,
            "initHeight":  337.0325363014519,
            "heading": 161.59642965699453,
            "pitch": -22.965258525664876
        },
            "NBX_ARJZNEX_QGBXP":{
            "dir": "NBX_ARJZNEX_QGBXP",
            "label": "NBX_ARJZNEX_QGBXP",
            "protected": true,
            "initLat": 35.49671946523897,
            "initLong": -97.51941543919447,
            "initHeight":  1375.4569277495798,
            "heading": 160.8036179060065,
            "pitch": -23.267991640580416
        },
            "NBX_UBHFR_ZNL":{
            "dir": "NBX_UBHFR_ZNL",
            "label": "NBX_UBHFR_ZNL",
            "protected": true,
            "initLat": 35.56011651131064,
            "initLong": -97.57187152790961,
            "initHeight":  669.0107186806355,
            "heading": 142.32861451908704,
            "pitch": -23.26624951579542
        },
            "NBX_BGN":{
            "dir": "NBX_BGN",
            "label": "NBX_BGN",
            "protected": true,
            "initLat": 35.51171247104242,
            "initLong": -97.48038113262491,
            "initHeight":  738.0055597181139,
            "heading": 153.78367483884765,
            "pitch": -19.374004069910317
        },
            "NBX_SBKUBYYBJ":{
            "dir": "NBX_SBKUBYYBJ",
            "label": "NBX_SBKUBYYBJ",
            "protected": true,
            "initLat": 36.862878704093546,
            "initLong": -95.86415799472302,
            "initHeight":  1313.0434139633662,
            "heading": 167.08149969459294,
            "pitch": -11.280092342959879
        },
            "NBX_GBCB":{
            "dir": "NBX_GBCB",
            "label": "NBX_GBCB",
            "protected": true,
            "initLat": 36.038705063215005,
            "initLong":  -99.30506334442643,
            "initHeight":  4073.4259623385137,
            "heading": 152.52598873404082,
            "pitch": -18.295723302651357
        },
            "NBX_QBYRFR":{
            "dir": "NBX_QBYRFR",
            "label": "NBX_QBYRFR",
            "protected": true,
            "initLat": 34.11142881047841,
            "initLong": -97.2622565731213,
            "initHeight":  2359.493639851251,
            "heading": 99.20916932704563,
            "pitch": -18.377447522272202
        },
            "NBX_UVAGBA":{
            "dir": "NBX_UVAGBA",
            "label": "NBX_UVAGBA",
            "protected": true,
                "initLat": 35.429296988372855,
                "initLong": -98.34335566509495,
                "initHeight": 2079.5928910161992,
                "pitch": -14.98381893564427,
                "heading": 347.0589536666831
        },
            "NBX_ARJZNEX1":{
            "dir": "NBX_ARJZNEX1",
            "label": "NBX_ARJZNEX1",
            "protected": true,
                "initLat": 35.500281128947535,
                "initLong": -97.54049397821741,
                "initHeight": 780.7151710063823,
                "pitch": -23.13342865990116,
                "heading": 133.06292393852385
        },
            "NBX_ARJZNEX2":{
                "dir": "NBX_ARJZNEX2",
                "label": "NBX_ARJZNEX2",
                "protected": true,
                "initLat": 35.69897778157207,
                "initLong": -97.36728056083729,
                "initHeight": 1064.5889394939488,
                "pitch": -8.004416922599315,
                "heading": 247.1097338075982
            },
            "NBX_CBAGFNAQF":{
            "dir": "NBX_CBAGFNAQF",
            "label": "NBX_CBAGFNAQF",
            "protected": true,
                "initLat": 34.48977397250795,
                "initLong": -96.68209513194319,
                "initHeight": 3274.996109269486,
                "pitch": -20.940942768028084,
                "heading": 55.978740101767045
        },
            "NBX_ARJZNEX_ABEZNA":{
            "dir": "NBX_ARJZNEX_ABEZNA",
            "label": "NBX_ARJZNEX_ABEZNA",
            "protected": true,
                "initLat": 35.17946333209838,
                "initLong": -97.42301529570996,
                "initHeight": 535.8577161889807,
                "pitch": -9.361474946216065,
                "heading": 125.43494894853933
        },
            "NBX_ARJZNEX_JRNGURESBEQ": {
            "dir": "NBX_ARJZNEX_JRNGURESBEQ",
            "label": "NBX_ARJZNEX_JRNGURESBEQ",
            "protected": true,
                "initLat": 35.534768736289976,
                "initLong": -98.68622205236885,
                "initHeight": 714.7846704920169,
                "pitch": -9.627397964966892,
                "heading": 203.62260202462326
        },
            "NBX_BQBG_29672":{
            "dir": "NBX_BQBG_29672",
            "label": "NBX_BQBG_29672",
            "protected": true,
                "initLat": 34.714025157809544,
                "initLong": -97.21178153379961,
                "initHeight": 1733.3059527142111,
                "pitch": -10.95671357922936,
                "heading": 21.822377737650605
        },
            "NBX_BQBG_31807":{
            "dir": "NBX_BQBG_31807",
            "label": "NBX_BQBG_31807",
            "protected": true,
                "initLat": 35.51192065524865,
                "initLong": -97.94505192638377,
                "initHeight": 648.5825242259215,
                "pitch": -14.084013041055902,
                "heading": 117.10958276829724
        },
            "NBX_BQBG_31892_YbirPbhagl":{
            "dir": "NBX_BQBG_31892_YbirPbhagl",
            "label": "NBX_BQBG_31892_YbirPbhagl",
            "protected": true,
                "initLat": 33.835631613815956,
                "initLong": -97.14902806272384,
                "initHeight": 1462.8735244669858,
                "pitch": -13.660287162370464,
                "heading": 165.15557844748733
        },
            "ovepuUvyy":{
                "dir": "ovepuUvyy",
                "label": "ovepuUvyy",
                "protected": true,
                "initLat": 35.66485647895322,
                "initLong": -97.36560176476311,
                "initHeight": 1175.9950682235904,
                "pitch": -22.336821723852655,
                "heading": 149.53461135982582
            }
        }

    ]
}

const getConf = (dataset, authed) => {
    if (dataset === undefined){
        for (const [value] of Object.entries(confs.availConfs[0])) {
            if (Boolean(authed)){
                labelArr.push([value.id, value.label])
            } else if (!value.protected && !Boolean(authed)) {
                labelArr.push([value.id, value.label])
            }
        }
        return labelArr

    } else {
        let datasetLookup = dataset.split("-")[0]
        return confs.availConfs[0][datasetLookup]
    }
}

export default getConf;
